module.exports = __webpack_public_path__ + "img/guangdong.7e8b7e93.jpg";